/* ==========================================================================
   Mondō London — singleton PDP add-to-bag
   The native product form is posted intact, then the canonical cart decides
   the permanent page state. Every offered piece has a quantity of one.
   ========================================================================== */
(function () {
  'use strict';
  var btn = document.querySelector('[data-add-btn]');
  var status = document.querySelector('[data-buy-status]');
  var form = btn && btn.closest('form');
  if (!btn || !form || !status) return;

  var label = btn.querySelector('.btn-label');
  var express = form.querySelector('[data-pay-express]');
  var submitting = false;
  var L = function (k) { return btn.getAttribute('data-l-' + k) || ''; };
  var shopifyRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
  var root = shopifyRoot || '/';
  if (root.charAt(root.length - 1) !== '/') root += '/';

  function endpoint(path) {
    return root + path.replace(/^\/+/, '');
  }

  function headerCount(n) {
    var el = document.querySelector('[data-cart-count]');
    if (el) el.textContent = n > 0 ? ' (' + n + ')' : '';
  }
  function setStatus(text, linkHref) {
    status.textContent = '';
    var em = document.createElement('em');
    em.textContent = text;
    status.appendChild(em);
    if (linkHref) {
      var a = document.createElement('a');
      a.className = 'buy-review';
      a.href = linkHref;
      a.setAttribute('aria-label', text);
      var proto = document.querySelector('.go');
      if (proto) a.appendChild(proto.cloneNode(true));
      else a.textContent = '→';
      status.appendChild(document.createTextNode(' '));
      status.appendChild(a);
    }
  }

  function setPending(pending) {
    btn.disabled = pending;
    btn.setAttribute('aria-disabled', pending ? 'true' : 'false');
    if (pending) {
      btn.setAttribute('aria-busy', 'true');
      btn.setAttribute('data-pending', '');
    } else {
      btn.removeAttribute('aria-busy');
      btn.removeAttribute('data-pending');
    }
  }

  function setAdded(cart) {
    btn.removeAttribute('data-uncertain');
    btn.disabled = true;
    btn.setAttribute('aria-disabled', 'true');
    btn.removeAttribute('aria-busy');
    btn.removeAttribute('data-pending');
    btn.setAttribute('data-added', '');
    label.textContent = L('added');
    if (express) express.hidden = true;
    if (cart && typeof cart.item_count === 'number') headerCount(cart.item_count);
    setStatus(
      status.getAttribute('data-l-in-bag') || 'In your bag — view',
      btn.getAttribute('data-cart-url') || endpoint('cart')
    );
    submitting = false;
  }

  function setSold() {
    btn.removeAttribute('data-added');
    btn.removeAttribute('data-uncertain');
    btn.disabled = true;
    btn.setAttribute('aria-disabled', 'true');
    btn.removeAttribute('aria-busy');
    btn.removeAttribute('data-pending');
    label.textContent = L('sold');
    if (express) express.hidden = true;
    setStatus(L('just-sold'));
    submitting = false;
  }

  function setRetryableError() {
    btn.removeAttribute('data-added');
    btn.removeAttribute('data-uncertain');
    setStatus(L('unreachable'));
    label.textContent = L('add');
    setPending(false);
    submitting = false;
  }

  function setUncertain() {
    btn.removeAttribute('data-added');
    btn.setAttribute('data-uncertain', '');
    btn.disabled = true;
    btn.setAttribute('aria-disabled', 'true');
    btn.removeAttribute('aria-busy');
    btn.removeAttribute('data-pending');
    label.textContent = L('add');
    if (express) express.hidden = true;
    setStatus(L('refresh') || 'Refresh this page before trying again.');
    submitting = false;
  }

  function fetchCart() {
    return fetch(endpoint('cart.js'), {
      headers: { 'Accept': 'application/json' }
    }).then(function (r) {
      if (!r.ok) throw new Error('cart unavailable');
      return r.json();
    });
  }

  function hasOwn(record, key) {
    return Object.prototype.hasOwnProperty.call(record, key);
  }

  function submittedConfiguration(data) {
    var configuration = {
      variantId: String(data.get('id') || ''),
      sellingPlanId: String(data.get('selling_plan') || ''),
      properties: {}
    };
    data.forEach(function (value, name) {
      var match = /^properties\[(.*)\]$/.exec(name);
      if (match && String(value) !== '') {
        configuration.properties[match[1]] = String(value);
      }
    });
    return configuration;
  }

  function lineMatchesConfiguration(item, configuration) {
    if (String(item.variant_id) !== configuration.variantId) return false;

    var actualProperties = item.properties || {};
    var expectedProperties = configuration.properties;
    var key;
    for (key in expectedProperties) {
      if (!hasOwn(expectedProperties, key)) continue;
      if (!hasOwn(actualProperties, key) ||
          String(actualProperties[key]) !== expectedProperties[key]) {
        return false;
      }
    }
    for (key in actualProperties) {
      if (!hasOwn(actualProperties, key) || key.charAt(0) === '_') continue;
      if (String(actualProperties[key]) === '') continue;
      if (!hasOwn(expectedProperties, key) ||
          String(actualProperties[key]) !== expectedProperties[key]) return false;
    }

    var allocation = item.selling_plan_allocation;
    var actualPlanId = allocation && allocation.selling_plan && allocation.selling_plan.id;
    return String(actualPlanId || '') === configuration.sellingPlanId;
  }

  function cartHasConfiguration(cart, configuration) {
    if (!cart || !Array.isArray(cart.items)) return false;
    return cart.items.some(function (item) {
      return lineMatchesConfiguration(item, configuration);
    });
  }

  function inventoryRejected(payload) {
    if (!payload || typeof payload !== 'object') return false;
    var message = typeof payload.message === 'string' ? payload.message : '';
    var description = typeof payload.description === 'string' ? payload.description : '';
    var text = message + ' ' + description;
    return /\bsold out\b|\bout of stock\b|\binventory\b|\bstock\b|\b(?:item|piece|product|variant)\b[^.]{0,50}\b(?:is|was)\s+(?:already\s+)?sold\b|\b(?:item|piece|product|variant)\b[^.]{0,50}\bhas\s+(?:been|just)\s+sold\b|\bnot enough (?:items? )?(?:are )?available\b|\bquantity\b[^.]{0,60}\bavailable\b/i.test(text);
  }

  function readErrorPayload(response) {
    return response.json().then(function (payload) {
      return payload || {};
    }, function () {
      return {};
    });
  }

  function announceCanonicalChange() {
    try {
      if (window.localStorage) {
        window.localStorage.setItem('mondo:cart-change', String(Date.now()));
      }
    } catch (e) {}
  }

  function reconcileCart(outcome, configuration, inventoryFailure) {
    return fetchCart().then(function (cart) {
      if (cartHasConfiguration(cart, configuration)) {
        setAdded(cart);
        announceCanonicalChange();
      } else if (outcome === 'confirmed') {
        // The write succeeded, but the canonical line does not match what was
        // submitted. Lock the form rather than risk a duplicate configuration.
        setUncertain();
      } else if (outcome === 'rejected' && inventoryFailure) {
        setSold();
      } else {
        setRetryableError();
      }
    }, function () {
      // A confirmed add must never become retryable: retrying could duplicate
      // a line even though only the follow-up cart read failed.
      if (outcome === 'confirmed') setAdded();
      else setUncertain();
    });
  }

  // Liquid owns the initial state, including a piece already in this cart.
  if (btn.hasAttribute('data-added') || btn.disabled) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (submitting || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;

    submitting = true;
    var data;
    try {
      data = new FormData(form);
    } catch (err) {
      setRetryableError();
      return;
    }
    var configuration = submittedConfiguration(data);
    if (!configuration.variantId) {
      submitting = false;
      return;
    }
    setPending(true);

    var request;
    try {
      request = fetch(endpoint('cart/add.js'), {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: data
      });
    } catch (err) {
      reconcileCart('ambiguous', configuration, false);
      return;
    }
    request.then(function (r) {
      if (r.ok) return reconcileCart('confirmed', configuration, false);
      if (r.status === 422) {
        return readErrorPayload(r).then(function (payload) {
          return reconcileCart('rejected', configuration, inventoryRejected(payload));
        });
      }
      return reconcileCart('ambiguous', configuration, false);
    }, function () {
      return reconcileCart('ambiguous', configuration, false);
    });
  });
})();

/* rare multi-size pieces — the checked radio is already the form's id input;
   here we only keep the printed price in step with the chosen size */
(function () {
  'use strict';
  var picker = document.querySelector('[data-variant-picker]');
  if (!picker) return;
  var price = document.querySelector('[data-pdp-price]');
  if (!price) return;
  picker.addEventListener('change', function (e) {
    var choice = e.target;
    if (!choice || choice.name !== 'id') return;
    var p = choice.getAttribute('data-price');
    if (p) price.textContent = p;
  });
})();

/* PDP catalogue disclosures — native details semantics with a composed close.
   Browsers remove closed details content before CSS can animate it, so the open
   attribute stays in place until the reverse transition has visibly finished. */
(function () {
  'use strict';
  var selector = 'details.trust';
  var closeFallbackMs = 620;
  var reduceMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)');

  function prefersReducedMotion() {
    return Boolean(reduceMotion && reduceMotion.matches);
  }

  function initDisclosure(details) {
    if (!details || details.getAttribute('data-trust-motion-ready') === 'true') return;

    var summary = details.querySelector('summary');
    var reveal = details.querySelector('.trust-reveal');
    if (!summary || !reveal) return;

    details.setAttribute('data-trust-motion-ready', 'true');
    var closing = false;
    var closeTimer = 0;

    function clearCloseTimer() {
      if (!closeTimer) return;
      window.clearTimeout(closeTimer);
      closeTimer = 0;
    }

    function cancelClose() {
      if (!closing) return;
      closing = false;
      clearCloseTimer();
      details.classList.remove('is-closing');
    }

    function finishClose() {
      if (!closing) return;
      closing = false;
      clearCloseTimer();
      details.open = false;
      details.classList.remove('is-closing');
    }

    summary.addEventListener('click', function (event) {
      if (prefersReducedMotion()) {
        if (closing) {
          event.preventDefault();
          finishClose();
        }
        return;
      }

      if (closing) {
        event.preventDefault();
        cancelClose();
        return;
      }

      if (!details.open) return;

      event.preventDefault();
      closing = true;
      details.classList.add('is-closing');
      closeTimer = window.setTimeout(finishClose, closeFallbackMs);
    });

    reveal.addEventListener('transitionend', function (event) {
      if (
        closing &&
        event.target === reveal &&
        event.propertyName === 'grid-template-rows'
      ) {
        finishClose();
      }
    });

  }

  function initWithin(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var disclosures = scope.querySelectorAll(selector);
    Array.prototype.forEach.call(disclosures, initDisclosure);
  }

  initWithin(document);
  if (document.addEventListener) {
    document.addEventListener('shopify:section:load', function (event) {
      initWithin(event.target);
    });
  }
})();
